// Hindi of src/content/learn/guides.ts. Keep keys and structure in step with the English.
import type { ArticleBody } from './types';

export const GUIDES_HI: Record<string, ArticleBody> = {
  'preparing-for-an-assessment': {
    intro: [
      'विकास से जुड़ी अपॉइंटमेंट अक्सर छोटी होती हैं और मुश्किल से मिलती हैं। थोड़ी तैयारी से विशेषज्ञ आपके बच्चे को वैसा देख पाते हैं जैसे वे सच में हैं, और आपको जवाब और एक योजना मिलती है।',
    ],
    extra: [
      {
        heading: 'विज़िट से पहले',
        blocks: [
          [
            'अपनी तीन सबसे बड़ी चिंताएँ क्रम से लिख लें। अपॉइंटमेंट की शुरुआत इन्हीं से करें।',
            'तारीख़ों के साथ उदाहरण लिखें: “नाम पुकारने पर जवाब नहीं देते, पीछे खड़े होकर ज़ोर से बुलाएँ, तब भी नहीं।”',
            'जिन बातों की चिंता है, उनके छोटे वीडियो बना लें; क्लिनिक में बच्चे अक्सर अलग तरह से बर्ताव करते हैं।',
            'पुरानी रिपोर्टें, सुनने और देखने की जाँचें, स्कूल के नोट्स और अपनी Nurture रिपोर्ट इकट्ठा कर लें।',
            'रिश्तेदारों या टीचर से पूछें कि वे क्या देखते हैं, इससे पता चलता है कि बातें एक से ज़्यादा जगह हो रही हैं या नहीं।',
          ],
        ],
      },
      {
        heading: 'विज़िट के दौरान',
        blocks: [
          [
            'नाश्ता, कोई पसंदीदा खिलौना और कपड़ों का एक अतिरिक्त जोड़ा साथ रखें।',
            'यह कहना बिल्कुल ठीक है कि “आम तौर पर इनका व्यवहार ऐसा नहीं होता।”',
            'विशेषज्ञ से कहें कि वे जो भी शब्द इस्तेमाल करें, उन्हें लिख दें, ताकि आप बाद में उनके बारे में पढ़ सकें।',
          ],
        ],
      },
      {
        heading: 'पूछने लायक सवाल',
        blocks: [
          [
            'आपको क्या लगता है, क्या हो रहा है, और आप कितने पक्के हैं?',
            'इसी हफ़्ते से, हमें घर पर क्या करना चाहिए?',
            'कौन-सी थेरेपी या सहायता मदद करेगी, कितनी बार, और ये हमें कहाँ मिल सकती हैं?',
            'हमें किन बातों पर नज़र रखनी चाहिए, और दोबारा कब आना चाहिए?',
            'क्या कुछ ऐसा है जो स्कूल को पता होना चाहिए या करना चाहिए?',
          ],
        ],
      },
    ],
    nurture: 'आपकी Nurture रिपोर्ट में विशेषज्ञों के लिए लिखा एक पेज है: आपने हमें क्या बताया, क्षेत्र-दर-क्षेत्र, उनकी भाषा में। विज़िट से पहले इसे प्रिंट करें या WhatsApp पर शेयर करें।',
    sources: [{ label: 'Rashtriya Bal Swasthya Karyakram (Government of India)', href: 'https://rbsk.mohfw.gov.in/' }],
  },

  'who-can-help': {
    intro: ['सही विशेषज्ञ ढूँढना भूलभुलैया जैसा लग सकता है। यहाँ बताया गया है कि कौन क्या करता है, ताकि आपको पता हो कि शुरुआत कहाँ से करें। कई बच्चे एक से ज़्यादा विशेषज्ञों से मिलते हैं।'],
    extra: [
      {
        heading: 'डॉक्टर',
        blocks: [
          [
            '**बच्चों के डॉक्टर (पीडियाट्रिशियन)**: बढ़त, सेहत या विकास से जुड़ी किसी भी चिंता के लिए आपका पहला पड़ाव। आगे दूसरे विशेषज्ञों के पास भेज सकते हैं।',
            '**बच्चों के विकास के विशेषज्ञ डॉक्टर (डेवलपमेंटल पीडियाट्रिशियन)**: बच्चों के ऐसे डॉक्टर जिन्होंने विकास में अतिरिक्त प्रशिक्षण लिया है; ऑटिज़्म, ADHD और विकास में देरी जैसी स्थितियों का आकलन और निदान करते हैं, और पूरी योजना का तालमेल सँभालते हैं।',
            '**बाल मनोचिकित्सक (चाइल्ड साइकियाट्रिस्ट)**: ऐसे डॉक्टर जो भावनात्मक, व्यवहार संबंधी और मानसिक स्वास्थ्य की स्थितियों का इलाज करते हैं, और ज़रूरत पड़ने पर दवा लिख सकते हैं।',
            '**बच्चों के न्यूरोलॉजिस्ट**: दौरे (सीज़र), सीखे हुए कौशलों के छूटने, या दिमाग़ और नसों से जुड़ी चिंताओं के लिए।',
          ],
        ],
      },
      {
        heading: 'थेरेपिस्ट और शिक्षक',
        blocks: [
          [
            '**बाल या क्लिनिकल मनोवैज्ञानिक (साइकोलॉजिस्ट)**: सीखने, सोचने और व्यवहार का आकलन करते हैं; एंग्ज़ायटी, व्यवहार और भावनाओं के लिए थेरेपी देते हैं; माता-पिता को ट्रेनिंग देते हैं।',
            '**स्पीच और लैंग्वेज थेरेपिस्ट**: समझना, बोलना, सामाजिक बातचीत, और खाना खाने व निगलने से जुड़ी दिक्कतें।',
            '**ऑक्युपेशनल थेरेपिस्ट (OT)**: रोज़मर्रा के कौशल: लिखावट, कपड़े पहनना, खाना, खेल, और संवेदी ज़रूरतें।',
            '**फ़िज़ियोथेरेपिस्ट**: चलना-फिरना, संतुलन, ताक़त और शरीर की मुद्रा (पोस्चर)।',
            '**स्पेशल एजुकेटर**: अलग तरह से सीखने वाले बच्चों के लिए पढ़ाने के तरीक़े; स्कूल में सहायता।',
            '**ऑडियोलॉजिस्ट**: सुनने की जाँच, बोलने में देरी वाले हर बच्चे के लिए।',
          ],
        ],
      },
      {
        heading: 'भारत में योग्यता की जाँच',
        blocks: [
          'भारत में मनोवैज्ञानिक, स्पेशल एजुकेटर और कई तरह के थेरेपी पेशेवर [भारतीय पुनर्वास परिषद (Rehabilitation Council of India)](https://rehabcouncil.nic.in/) में पंजीकृत होते हैं। किसी विशेषज्ञ से उनकी योग्यता और पंजीकरण के बारे में पूछना बिल्कुल ठीक है।',
          '[राष्ट्रीय बाल स्वास्थ्य कार्यक्रम (Rashtriya Bal Swasthya Karyakram)](https://rbsk.mohfw.gov.in/) के तहत सरकारी ज़िला अर्ली इंटरवेंशन सेंटर (DEIC) छोटे बच्चों के लिए मुफ़्त स्क्रीनिंग और शुरुआती मदद (अर्ली इंटरवेंशन) देते हैं।',
        ],
      },
    ],
    nurture: 'आपकी रिपोर्ट बताती है कि जो बातें ख़ास दिखीं, उनके लिए किस तरह का विशेषज्ञ सही रहेगा, और आप अपने बच्चे की केयर टीम को ऐप में रख सकते हैं।',
    sources: [
      { label: 'Rehabilitation Council of India', href: 'https://rehabcouncil.nic.in/' },
      { label: 'Rashtriya Bal Swasthya Karyakram (Government of India)', href: 'https://rbsk.mohfw.gov.in/' },
    ],
  },

  'udid-and-school-rights': {
    intro: [
      'भारत का **दिव्यांगजन अधिकार अधिनियम, 2016 (Rights of Persons with Disabilities Act)** 21 तरह की दिव्यांगताओं को मान्यता देता है, जिनमें ऑटिज़्म स्पेक्ट्रम डिसऑर्डर, विशिष्ट सीखने की अक्षमताएँ (स्पेसिफ़िक लर्निंग डिसेबिलिटी), बौद्धिक अक्षमता, बोलने और भाषा की दिव्यांगता, और सेरेब्रल पाल्सी शामिल हैं। यह बच्चों को समावेशी शिक्षा और उचित सहायता का अधिकार देता है।',
      'यह पेज सामान्य जानकारी है, क़ानूनी सलाह नहीं। नियम और प्रक्रियाएँ राज्य के हिसाब से अलग हो सकती हैं; अपने राज्य के दिव्यांगजन विभाग या अपने बच्चे के स्कूल से पता करें।',
    ],
    extra: [
      {
        heading: 'UDID कार्ड',
        blocks: [
          'यूनिक डिसेबिलिटी ID (UDID) कार्ड एक ही राष्ट्रीय दिव्यांगता प्रमाणपत्र और पहचान पत्र है। यह स्कूल में सहायता, परीक्षा में मिलने वाली सुविधाओं और सरकारी योजनाओं में मदद कर सकता है।',
          [
            '[swavlambancard.gov.in](https://www.swavlambancard.gov.in/) पर ऑनलाइन आवेदन करें।',
            'आपको एक फ़ोटो, पहचान और पते का प्रमाण, और आपके पास मौजूद सभी मेडिकल रिपोर्टें चाहिए होंगी।',
            'आपसे आकलन के लिए किसी सरकारी अस्पताल या मेडिकल बोर्ड जाने को कहा जाएगा; प्रमाणपत्र में दिव्यांगता का प्रकार और प्रतिशत लिखा होता है।',
            'हर रिपोर्ट और आवेदन संख्या की कॉपी रखें।',
          ],
        ],
      },
      {
        heading: 'स्कूल में',
        blocks: [
          [
            'सरकार द्वारा वित्तपोषित या मान्यता प्राप्त स्कूलों को दिव्यांग बच्चों को बिना भेदभाव के दाख़िला देना होगा और उचित सुविधाएँ (रीज़नेबल अकोमोडेशन) देनी होंगी।',
            'स्कूल से उचित सुविधाओं के बारे में पूछें, जैसे अतिरिक्त समय, पढ़कर सुनाने वाला (रीडर) या लिखने वाला (स्क्राइब), या टीचर के पास बैठने की जगह, और यह भी कि इन्हें तय करने के लिए उन्हें आपसे क्या चाहिए।',
            'परीक्षा बोर्डों के सुविधाओं से जुड़े अपने नियम होते हैं; बोर्ड परीक्षाओं से काफ़ी पहले, जल्दी स्कूल से पूछें।',
            'अपने अनुरोध लिखित में दें और जवाबों की कॉपी रखें।',
          ],
        ],
      },
    ],
    nurture: 'Nurture रिपोर्ट दिव्यांगता प्रमाणपत्र नहीं है, लेकिन जब आप आकलन के लिए कहें, तो इसका केयर टीम वाला पेज साथ ले जाने के लिए एक उपयोगी सारांश है।',
    sources: [
      { label: 'Department of Empowerment of Persons with Disabilities; Acts', href: 'https://depwd.gov.in/acts/' },
      { label: 'UDID portal (Swavlamban Card)', href: 'https://www.swavlambancard.gov.in/' },
    ],
  },

  'caring-for-yourself': {
    intro: [
      'ख़ास ज़रूरतों वाले बच्चे की परवरिश एक साथ ख़ुशी भरी भी हो सकती है और थका देने वाली भी। अपॉइंटमेंट, थेरेपी, हर किसी की सलाह, भविष्य की चिंता, यह सब जुड़ता जाता है। अपना ख़याल रखना स्वार्थ नहीं है; यह अपने बच्चे का ख़याल रखने का ही हिस्सा है।',
    ],
    extra: [
      {
        heading: 'छोटी बातें जो मदद करती हैं',
        blocks: [
          [
            'बोझ बाँटें: जीवनसाथी, दादा-दादी या नाना-नानी, या किसी दोस्त को एक नियमित काम दें (थेरेपी पर ले जाना, नहलाना)।',
            'दिन में दस मिनट सिर्फ़ अपने लिए रखें, बालकनी में चाय पीना भी गिना जाता है।',
            'ऐसे दूसरे माता-पिता ढूँढें जो समझते हों। थेरेपी के वेटिंग रूम और पैरेंट ग्रुप बड़ा सहारा बन सकते हैं।',
            'ऐसी सलाह को ना कहें जिससे लगे कि आपको परखा जा रहा है। आप अपने बच्चे को जानते हैं।',
            'जितना हो सके, नियमित रूप से सोएँ और खाएँ; आपके धैर्य पर इनका असर किसी भी और चीज़ से ज़्यादा होता है।',
          ],
        ],
      },
      {
        heading: 'जब बात थकान से ज़्यादा हो',
        blocks: [
          'अगर ज़्यादातर दिन मन उदास रहता है, किसी चीज़ में ख़ुशी नहीं मिलती, निराशा घेरे रहती है, या ख़ुद को नुक़सान पहुँचाने के ख़याल आते हैं, तो कृपया अभी मदद लें। **Tele-MANAS 14416** मुफ़्त और गोपनीय है, और कई भारतीय भाषाओं में 24×7 उपलब्ध है।',
        ],
      },
    ],
    nurture: 'Nurture बनाने वाली कंपनी ZenQuip एक मानसिक स्वास्थ्य सेवा है। इसमें आप अकेले नहीं हैं।',
    sources: [{ label: 'Tele-MANAS (Government of India)', href: 'https://telemanas.mohfw.gov.in/' }],
  },

  'milestones-what-to-expect': {
    intro: [
      'बच्चे अपनी रफ़्तार से बढ़ते हैं, और इसमें काफ़ी अंतर सामान्य है। विकास के पड़ाव एक मार्गदर्शन हैं, कोई परीक्षा नहीं। सबसे ज़रूरी यह है कि आपका बच्चा नई चीज़ें सीखता रहे, और यह कि कहीं कुछ पहले से या उसी उम्र के दूसरे बच्चों से अलग तो नहीं लग रहा।',
    ],
    extra: [
      {
        heading: 'लगभग 18 महीने',
        blocks: [
          [
            'चीज़ें दिखाने के लिए उँगली से इशारा करता है, और जो देखता है उसे बाँटने के लिए आपकी ओर देखता है।',
            'कई अकेले शब्द बोलता है और “गेंद दो” जैसी सरल बातें समझता है।',
            'स्थिरता से चलता है और दौड़ना शुरू करता है। ख़ुद खाने की कोशिश करता है।',
            'आपकी नक़ल करता है, जैसे झाड़ू लगाना या फ़ोन पर बात करना।',
          ],
        ],
      },
      {
        heading: 'लगभग 2 साल',
        blocks: [
          [
            'दो शब्द जोड़ता है, जैसे “और दूध”।',
            'नाम लेने पर शरीर के अंगों और तस्वीरों की ओर इशारा करता है।',
            'दौड़ता है, गेंद पर किक मारता है और नीचे के फ़र्नीचर पर चढ़ता है।',
            'खेल-खेल में नक़ल करना शुरू करता है, जैसे गुड़िया को खिलाना, और दूसरे बच्चों में रुचि दिखाता है।',
          ],
        ],
      },
      {
        heading: 'लगभग 3 साल',
        blocks: [
          [
            'छोटे वाक्य बोलता है, और परिवार के बाहर के लोग भी उसकी काफ़ी बात समझ लेते हैं।',
            'काल्पनिक खेल खेलता है, और थोड़ी मदद से बारी-बारी से खेलता है।',
            'सीढ़ियाँ चढ़ता है, दोनों पैरों से कूदता है और शायद तिपहिया साइकिल चलाता है।',
            'कई तरह की भावनाएँ दिखाता है और शांत कराने पर शांत हो जाता है।',
          ],
        ],
      },
      {
        heading: 'लगभग 4 से 5 साल',
        blocks: [
          [
            'एक सरल कहानी सुनाता है और “क्यों” वाले सवालों के जवाब देता है।',
            'सिर, शरीर और हाथ-पैर वाला इंसान बनाता है।',
            'थोड़ी मदद से कपड़े पहनता है और शौचालय का इस्तेमाल करता है।',
            'दूसरे बच्चों के साथ खेलता है और खेल के सरल नियम मानता है।',
          ],
        ],
      },
      {
        heading: 'इन बातों पर जल्दी विशेषज्ञ से बात करें',
        blocks: [
          [
            'आपका बच्चा कोई सीखा हुआ हुनर खो दे, जैसे शब्द, नज़र मिलाना या खेलने का पसंदीदा तरीक़ा। इसमें किसी भी उम्र में इंतज़ार न करें।',
            'वह अपने नाम या रोज़ की आवाज़ों पर मुड़कर नहीं देखता।',
            '18 महीने तक इशारा करना या दिखाना नहीं, 16 महीने तक अकेले शब्द नहीं, या 2 साल तक दो शब्दों वाले वाक्य नहीं।',
            'वह 18 महीने तक चलना शुरू नहीं करता।',
            'वह लोगों में बहुत कम रुचि दिखाता है, या आम आवाज़ों, छुअन या बदलावों से बहुत परेशान हो जाता है।',
            'आपको बस यह लगता है कि कुछ अलग है। इस एहसास पर भरोसा करें और पूछें।',
          ],
        ],
      },
    ],
    nurture: 'Nurture आकलन आपके बच्चे की उम्र के पड़ावों के बारे में पूछता है और क्षेत्र दर क्षेत्र दिखाता है कि क्या ठीक चल रहा है और क्या किसी विशेषज्ञ से बात करने या ध्यान से देखने लायक़ है।',
    sources: [
      { label: 'CDC: Learn the Signs. Act Early.', href: 'https://www.cdc.gov/act-early/' },
      { label: 'राष्ट्रीय बाल स्वास्थ्य कार्यक्रम (भारत सरकार)', href: 'https://rbsk.mohfw.gov.in/' },
    ],
  },

  'why-early-support-matters': {
    intro: [
      'छोटे बच्चे का दिमाग़ बाद की किसी भी उम्र से तेज़ी से सीखता है। जो मदद जल्दी शुरू होती है, उसके पास असर दिखाने के लिए ज़्यादा समय होता है, और परिवार को महीनों तक सोचते रहने की चिंता भी कम झेलनी पड़ती है। इसीलिए देर से नहीं, जल्दी पूछना बेहतर है।',
    ],
    extra: [
      {
        heading: 'जल्दी मदद असल में क्या है',
        blocks: [
          [
            'हर दिन साथ बात करना, गाना, पढ़ना और खेलना। यही इसका मूल है।',
            'दिनचर्या में छोटे बदलाव, जिनसे आपके बच्चे का दिन आसान हो जाए।',
            'ज़रूरत हो तो थेरेपी, जैसे स्पीच, ऑक्यूपेशनल या बिहेवियरल थेरेपी, और सत्रों के बीच घर पर अभ्यास।',
            'मदद किसी लेबल पर निर्भर नहीं है। आप किसी निदान से पहले भी मदद शुरू कर सकते हैं।',
          ],
        ],
      },
      {
        heading: '“देखते हैं” में समय क्यों चला जाता है',
        blocks: [
          [
            'अपॉइंटमेंट और थेरेपी की जगहों के लिए अक्सर इंतज़ार की सूची होती है। जल्दी शुरू करने का मतलब है कि इंतज़ार के दौरान आप घर पर पहले से मदद कर रहे होते हैं।',
            'आकलन जानकारी देता है, फ़ैसला नहीं। यह बताता है कि आपके बच्चे को कहाँ मदद चाहिए और वह कहाँ मज़बूत है।',
            'हुनर एक-दूसरे पर टिके होते हैं। शुरुआती संवाद या खेल में मदद से आगे की पढ़ाई-लिखाई आसान होती है।',
          ],
        ],
      },
      {
        heading: 'कभी देर नहीं होती',
        blocks: [
          'बच्चे हर उम्र में प्रगति करते हैं। अगर आपका बच्चा बड़ा है, तो अभी शुरू करें। जल्दी का मतलब बस ज़्यादा समय है, यह नहीं कि बाद में बहुत देर हो चुकी है।',
        ],
      },
      {
        heading: 'शुरुआत कहाँ से करें',
        blocks: [
          [
            'अपने बाल रोग विशेषज्ञ या फ़ैमिली डॉक्टर से शुरू करें और सुनने व देखने की जाँच माँगें, क्योंकि दोनों बोलने और सीखने पर असर डालते हैं।',
            'अपने ज़िला अस्पताल में पूछें कि क्या ज़िला शीघ्र हस्तक्षेप केंद्र (DEIC) उपलब्ध है। राष्ट्रीय बाल स्वास्थ्य कार्यक्रम के तहत ये केंद्र बच्चों की जाँच करते हैं और शुरुआती मदद में सहयोग देते हैं।',
            'किसी भी अपॉइंटमेंट में अपनी Nurture रिपोर्ट साथ ले जाएँ। इससे विशेषज्ञ को एक साफ़ सार मिल जाता है।',
          ],
        ],
      },
    ],
    nurture: 'Nurture रिपोर्ट उस बातचीत की शुरुआत है। यह दिखाती है कि कौन से क्षेत्र ठीक चल रहे हैं और किन्हें क़रीब से देखना चाहिए, साथ में घर पर आज़माने के विचार भी, जब तक आप अपॉइंटमेंट तय करते हैं।',
    sources: [{ label: 'राष्ट्रीय बाल स्वास्थ्य कार्यक्रम (भारत सरकार)', href: 'https://rbsk.mohfw.gov.in/' }],
  },

  'myths-and-facts': {
    intro: [
      'जिन बच्चों का विकास अलग ढंग से होता है, उनके बारे में परिवारों को बहुत सलाह मिलती है, और उनमें से कुछ ग़लत होती है। कुछ मिथक अपराध-बोध पैदा करते हैं, और कुछ देरी। यहाँ वे मिथक हैं जो हम सबसे ज़्यादा सुनते हैं, और असल में क्या पता है।',
    ],
    myths: [
      { myth: 'ऑटिज़्म बुरी परवरिश या ठंडे स्वभाव की माँ की वजह से होता है।', fact: 'नहीं। ऑटिज़्म दिमाग़ के विकास के अंतर से आता है, और अक्सर परिवारों में चलता है। माता-पिता इसकी वजह नहीं हैं।' },
      { myth: 'टीकों से ऑटिज़्म होता है।', fact: 'कई देशों के बड़े अध्ययनों में टीकों और ऑटिज़्म के बीच कोई संबंध नहीं मिला। कृपया अपने बच्चे के टीके समय पर लगवाएँ।' },
      { myth: 'जब तैयार होगा, बोलने लगेगा। लड़के हमेशा देर से बोलते हैं।', fact: 'कुछ बच्चे पकड़ लेते हैं, पर पहले से कोई नहीं बता सकता कि कौन से। सुनने की जाँच और विकास की जाँच जल्दी हो जाती है, और बताती है कि मदद चाहिए या नहीं।' },
      { myth: 'जो बच्चा नज़र मिलाता है या जिसके दोस्त हैं, उसे ऑटिज़्म नहीं हो सकता।', fact: 'बच्चे बहुत अलग-अलग होते हैं। संकेत हल्के हो सकते हैं, ख़ासकर लड़कियों में, और कई बार सालों तक पकड़ में नहीं आते।' },
      { myth: 'ADHD वाले बच्चे बस शरारती या आलसी होते हैं।', fact: 'ADHD में ध्यान और आवेग पर क़ाबू अलग ढंग से विकसित होता है। इन बच्चों को समझ और सहारे की ज़रूरत है, ज़्यादा सज़ा की नहीं।' },
      { myth: 'लेबल से मेरे बच्चे को नुक़सान होगा, इसलिए न पूछना ही बेहतर है।', fact: 'न जानना, जानने से ज़्यादा नुक़सान करता है। साफ़ तस्वीर ही मदद, स्कूल के सहयोग और घर पर समझ का दरवाज़ा खोलती है।' },
      { myth: 'कोई ख़ास डाइट या सप्लीमेंट ऑटिज़्म या ADHD को ठीक कर सकता है।', fact: 'किसी डाइट या सप्लीमेंट से इनमें से किसी के ठीक होने का प्रमाण नहीं है। खाने की चीज़ें बंद करने से पहले कृपया डॉक्टर से बात करें, क्योंकि बच्चों को बढ़ने के लिए संतुलित आहार चाहिए।' },
      { myth: 'स्क्रीन से ऑटिज़्म होता है।', fact: 'स्क्रीन से ऑटिज़्म होने का कोई प्रमाण नहीं है। फिर भी स्क्रीन पर लंबे घंटे बातचीत और खेल का समय खा सकते हैं, जो बच्चों को चाहिए।' },
    ],
    nurture: 'Nurture रिपोर्ट आपके बताए के आधार पर आपके बच्चे को देखती है और उसे सरल शब्दों में समझाती है। यह निदान नहीं है, और आपके बच्चे पर लेबल नहीं लगाती।',
    sources: [{ label: 'विश्व स्वास्थ्य संगठन: ऑटिज़्म स्पेक्ट्रम विकार', href: 'https://www.who.int/news-room/fact-sheets/detail/autism-spectrum-disorders' }],
  },

  'talking-to-family-and-friends': {
    intro: [
      'दादा-दादी, चाचा-चाची, पड़ोसी और दूसरे माता-पिता अक्सर भले इरादे से बोलते हैं, पर “बिगड़ा हुआ है” या “आप ज़्यादा सोचती हैं” जैसी बातें चुभती हैं। शांति से कहे कुछ सरल शब्द परिवार के आपके बच्चे को समझने का तरीक़ा बदल सकते हैं।',
    ],
    extra: [
      {
        heading: 'कुछ सरल बातें जो आप कह सकते हैं',
        blocks: [
          [
            '“हम डॉक्टर के साथ यह समझ रहे हैं कि वह सबसे अच्छा कैसे सीखता है।”',
            '“उसे थोड़ा ज़्यादा समय और एक अलग तरह की मदद चाहिए। हम वही दे रहे हैं।”',
            '“सबसे ज़्यादा धैर्य और शांत आवाज़ काम आती है। कोशिश करने के लिए धन्यवाद।”',
            '“हम इसे अपने ढंग से संभालना चाहते हैं। सलाह की ज़रूरत हुई तो आपको बताएँगे।”',
          ],
        ],
      },
      {
        heading: 'दादा-दादी को साथ लाना',
        blocks: [
          [
            'उन्हें थेरेपी सत्र या घर की किसी गतिविधि को देखने बुलाएँ, ताकि वे देखें कि क्या काम करता है।',
            'लंबी सूची की जगह एक-दो सरल सुझाव साझा करें, जैसे बदलाव से पहले चेतावनी देना।',
            'उन्हें अच्छे पल भी बाँटने दें। बताएँ कि आपके बच्चे ने हाल में क्या सीखा।',
            'अगर इससे उन्हें वही तस्वीर दिखती है, तो आप अपनी Nurture रिपोर्ट का एक पन्ना WhatsApp पर भेज सकते हैं।',
          ],
        ],
      },
      {
        heading: 'जब बच्चा सबके सामने परेशान हो',
        blocks: [
          [
            'अजनबियों को समझाना ज़रूरी नहीं। एक छोटी पंक्ति काफ़ी है: “अभी उसका मुश्किल पल है। सब ठीक हो जाएगा।”',
            'पहले अपने बच्चे पर ध्यान दें। हो सके तो किसी शांत जगह चले जाएँ।',
            'जो लोग आपके क़रीब हैं, उनसे कहें कि टिप्पणी न करें, मदद करें।',
          ],
        ],
      },
      {
        heading: 'क्या बताना है, यह आप तय करें',
        blocks: [
          'आपके बच्चे की सेहत की जानकारी निजी है। जितना चाहें उतना ही बताएँ, और सिर्फ़ उन्हें जो उसे संवेदनशीलता से लेंगे। ऐसे शब्द चुनें जिन्हें सुनकर आपके बच्चे को बुरा न लगे।',
        ],
      },
    ],
    nurture: 'Nurture का परिवार फ़ीचर आपको किसी दूसरे वयस्क को आपके बच्चे की रिपोर्ट देखने की सिर्फ़ पढ़ने की अनुमति देने देता है, ताकि वे वही तस्वीर देखें जो आप देखते हैं।',
    sources: [{ label: 'टेली-मानस (भारत सरकार)', href: 'https://telemanas.mohfw.gov.in/' }],
  },

  'supporting-brothers-and-sisters': {
    intro: [
      'जब एक बच्चे को ज़्यादा समय और ध्यान चाहिए, तो भाई-बहन यह देखते हैं। वे गर्व, उलझन, जलन या अकेलापन महसूस कर सकते हैं, कभी-कभी एक ही दिन में सब। उन पर थोड़ा-सा ध्यान बहुत फ़र्क़ डालता है।',
    ],
    extra: [
      {
        heading: 'ऐसे शब्दों में समझाएँ जो वे समझें',
        blocks: [
          [
            'उन्हें सरल शब्दों में बताएँ कि उनका भाई या बहन कैसे अलग है: “उसका दिमाग़ तेज़ आवाज़ों को मुश्किल पाता है, इसलिए वह कान बंद कर लेती है।”',
            'साफ़ कहें कि यह किसी की ग़लती नहीं है, और यह छूत की बात नहीं है।',
            'सवालों का ईमानदारी से जवाब दें, और उन्हें बाद में फिर पूछने दें।',
          ],
        ],
      },
      {
        heading: 'अलग से समय बचाकर रखें',
        blocks: [
          [
            'रोज़ दस मिनट जो सिर्फ़ उनके हों, बिना फ़ोन के, महीने में एक बड़ी सैर से ज़्यादा मायने रखते हैं।',
            'गतिविधि उन्हें चुनने दें।',
            'उनकी अपनी उपलब्धियों का उतने ही उत्साह से जश्न मनाएँ जितना किसी और का।',
          ],
        ],
      },
      {
        heading: 'उन्हें भूमिका दें, बोझ नहीं',
        blocks: [
          [
            'भाई-बहन बहुत अच्छे खेल-साथी बन सकते हैं। उन्हें गतिविधियों में शामिल होने बुलाएँ।',
            'उन्हें देखभाल करने वाला न बनाएँ। बचपन बचपन ही रहना चाहिए।',
            'निष्पक्ष का मतलब हमेशा बराबर नहीं होता। समझाएँ कि हर बच्चे को वही मिलता है जिसकी उसे ज़रूरत है।',
          ],
        ],
      },
      {
        heading: 'संकेत देखें कि वे मुश्किल में तो नहीं',
        blocks: [
          'मूड, स्कूल के नंबर, नींद या खाने में अचानक बदलाव का मतलब हो सकता है कि वे चिंता ढो रहे हैं। उनसे बात करें, और अगर यह बना रहे तो उनके स्कूल काउंसलर या अपने डॉक्टर से पूछें।',
        ],
      },
    ],
    nurture: 'Nurture होम प्रोग्राम छोटी गतिविधियाँ सुझाता है जिनमें भाई या बहन भी शामिल हो सकते हैं, ताकि खेल का समय सबके लिए अभ्यास का समय बन जाए।',
    sources: [{ label: 'टेली-मानस (भारत सरकार)', href: 'https://telemanas.mohfw.gov.in/' }],
  },

  'routines-that-help-at-home': {
    intro: [
      'जब दिन का क्रम अनुमान में हो, तो कई बच्चे ज़्यादा शांत रहते हैं और तेज़ी से सीखते हैं। दिनचर्या का सख़्त होना ज़रूरी नहीं। उसका साफ़ होना और ज़्यादातर दिन एक जैसा होना ज़रूरी है।',
    ],
    extra: [
      {
        heading: 'दिन को दिखने लायक़ बनाएँ',
        blocks: [
          [
            'दीवार पर एक सरल तस्वीरों वाला कार्यक्रम लगाएँ: उठना, ब्रश, नाश्ता, खेल, नहाना, कहानी, सोना। फ़ोटो या चित्र, दोनों चलते हैं।',
            'हर काम पूरा होने पर एक तस्वीर हटा दें या उलट दें। आपका बच्चा देख सकता है कि क्या पूरा हुआ और आगे क्या है।',
            'शुरू में इसे चार-पाँच क़दमों तक रखें।',
          ],
        ],
      },
      {
        heading: 'बदलावों को आसान बनाएँ',
        blocks: [
          [
            'बदलाव से पहले चेतावनी दें: “पाँच मिनट और, फिर नहाना।” टाइमर मदद करता है।',
            '“पहले, फिर” का इस्तेमाल करें: “पहले जूते, फिर पार्क।”',
            'किसी बदलाव के बारे में पहले से बताएँ, जैसे मेहमान का आना या स्कूल बस का अलग होना।',
          ],
        ],
      },
      {
        heading: 'छोटे से शुरू करें और जारी रखें',
        blocks: [
          [
            'दिन का वह एक समय चुनें जो सबसे मुश्किल है, अक्सर सुबह या सोने का समय, और पहले उसी पर काम करें।',
            'यह परखने से पहले कि इससे मदद मिल रही है, दो हफ़्ते तक वही क़दम उसी क्रम में करें।',
            'सिर्फ़ नतीजे की नहीं, कोशिश की भी तारीफ़ करें। “तुमने ख़ुद जूते पहन लिए!”',
            'आराम और खुले खेल के लिए जगह छोड़ें। दिनचर्या एक ढाँचा है, टाइमटेबल नहीं।',
          ],
        ],
      },
    ],
    nurture: 'Nurture होम प्रोग्राम हर हफ़्ते की गतिविधियों को दिन के उन समयों में रखता है जो आपके पास पहले से हैं, और मुश्किल पलों के लिए एक सरल दिनचर्या और फ़्रिज शीट भी देता है।',
    sources: [{ label: 'CDC: Learn the Signs. Act Early.', href: 'https://www.cdc.gov/act-early/' }],
  },

  'more-than-one-language': {
    intro: [
      'भारत में कई बच्चे दो, तीन या उससे ज़्यादा भाषाएँ सुनते हुए बड़े होते हैं। परिवारों को कभी चिंता होती है कि इससे बोलना देर से आता है, और उन्हें बस एक भाषा बोलने को कहा जाता है। प्रमाण कुछ और कहते हैं।',
    ],
    myths: [
      { myth: 'घर पर एक से ज़्यादा भाषा बोलने से बोलने में देरी होती है।', fact: 'ऐसा नहीं होता। बच्चे एक साथ कई भाषाएँ सीख सकते हैं। असली देरी उनकी सभी भाषाओं में दिखेगी, और उसकी जाँच ज़रूरी है, चाहे कोई भी भाषा बोली जाए।' },
      { myth: 'हमें घर की भाषा छोड़कर सिर्फ़ अंग्रेज़ी बोलनी चाहिए।', fact: 'जिस भाषा में आप सबसे सहज हैं, उसी में बोलते रहें। उस भाषा में भरपूर, स्वाभाविक बातचीत आपके बच्चे की अटकती अंग्रेज़ी से ज़्यादा मदद करती है।' },
    ],
    extra: [
      {
        heading: 'क्या मदद करता है',
        blocks: [
          [
            'जिस भाषा में आप सबसे अच्छा बोलते हैं, उसी में बात करें, गाएँ और पढ़ें। गर्मजोशी भरी स्वाभाविक बातचीत ही भाषा बनाती है।',
            'हर व्यक्ति अपनी भाषा पर टिक सकता है, या परिवार भाषाएँ मिला सकता है। दोनों चलता है।',
            'बच्चे को कितने शब्द आते हैं, यह सोचते समय उसकी सभी भाषाएँ साथ गिनें।',
            'अपनी परंपरा की कहानियाँ, गीत और तुकबंदियाँ इस्तेमाल करें। इनमें भाषा भरी होती है।',
          ],
        ],
      },
      {
        heading: 'विशेषज्ञ से कब पूछें',
        blocks: [
          [
            'आपका बच्चा लगभग 16 महीने तक अकेले शब्द, या लगभग 2 साल तक दो शब्दों वाले वाक्य, किसी भी भाषा में नहीं बोल रहा।',
            'वह किसी भी भाषा में सरल बातें नहीं समझता लगता।',
            'वह जो शब्द बोलता था, उन्हें खो देता है।',
            'ऐसे स्पीच और लैंग्वेज थेरेपिस्ट को चुनें जो आपकी घर की भाषाएँ समझते हों, या जो आपको उस भाषा में थेरेपी में शामिल कर सकें जो आप बोलते हैं।',
          ],
        ],
      },
    ],
    nurture: 'Nurture आकलन आपके बच्चे की उम्र के हिसाब से संवाद के बारे में पूछता है। जवाब इस आधार पर दें कि वह कुल मिलाकर कैसे संवाद करता है, वह जो भी भाषाएँ इस्तेमाल करे।',
    sources: [{ label: 'American Speech-Language-Hearing Association', href: 'https://www.asha.org/' }],
  },

  'keeping-your-child-safe': {
    intro: [
      'कुछ बच्चों को, ख़ासकर जो बहुत सक्रिय हों, ख़तरा न भाँपते हों, या भाग जाना पसंद करते हों, ज़्यादा सुरक्षा योजना चाहिए। कुछ सरल क़दम घर को क़िला बनाए बिना आपको चैन दे सकते हैं।',
    ],
    extra: [
      {
        heading: 'घर पर',
        blocks: [
          [
            'खिड़कियों पर जाली और बालकनी में सुरक्षा लगवाएँ, और मुख्य दरवाज़े की कुंडी ऊँची रखें।',
            'दवाइयाँ, सफ़ाई के सामान और नुकीली चीज़ें पहुँच से दूर या ताले में रखें।',
            'दरवाज़े का अलार्म या घंटी बताती है कि कोई बाहर गया।',
            'अपने फ़ोन में बच्चे की हाल की एक फ़ोटो रखें।',
          ],
        ],
      },
      {
        heading: 'बाहर और भीड़ में',
        blocks: [
          [
            'सड़क के पास हाथ पकड़ें। “रुको” और “ठहरो” का अभ्यास खेल की तरह करें।',
            'अपने बच्चे को आपके फ़ोन नंबर वाला आईडी बैंड या कार्ड पहनाएँ, या उसके कपड़ों में सिल दें।',
            'जिन पर आप भरोसा करते हैं, जैसे पड़ोसी, स्कूल बस का स्टाफ़ और दुकानदार, उन्हें बताएँ कि आपका बच्चा भटक सकता है, और उनसे कहें कि आपको फ़ोन करें।',
          ],
        ],
      },
      {
        heading: 'पानी',
        blocks: [
          [
            'भटकने वाले बच्चों के लिए पानी सबसे बड़ा जोखिम है। बाल्टियाँ, टब और टंकियाँ ढककर या ख़ाली रखें।',
            'तालाब, पूल और समुद्र तट पर, लाइफ़जैकेट के साथ भी, हमेशा हाथ की पहुँच में रहें।',
            'ऐसे प्रशिक्षक से तैराकी सीखना, जो आपके बच्चे को समझता हो, जीवन भर काम आने वाला सुरक्षा हुनर है।',
          ],
        ],
      },
      {
        heading: 'अगर आपका बच्चा खो जाए',
        blocks: [
          [
            'तुरंत **112** पर फ़ोन करें। यह देखने के लिए इंतज़ार न करें कि वह लौटता है या नहीं।',
            'सबसे पहले पानी की जगहें देखें, भले ही आपका बच्चा पहले कभी उसके पास न गया हो।',
            'पुलिस को अपने बच्चे का नाम, उम्र, कपड़े और वह बताएँ जो मदद कर सकता है, जैसे कुछ जगहें जो उसे पसंद हों या बोलने में कठिनाई।',
          ],
        ],
      },
      {
        heading: 'ये नंबर भी रखें',
        blocks: [
          [
            '**चाइल्डलाइन 1098** देखभाल और सुरक्षा की ज़रूरत वाले किसी भी बच्चे के लिए है।',
            '**टेली-मानस 14416** मुफ़्त और गोपनीय है, और अगर आपको या परिवार के किसी सदस्य को किसी से बात करनी हो तो 24×7 खुला है।',
          ],
        ],
      },
    ],
    nurture: 'Nurture की केयर-टीम वाला पन्ना और रिपोर्ट बताते हैं कि आप अपने डॉक्टर से क्या ज़िक्र कर सकते हैं। सुरक्षा से जुड़ी जो भी बात आपको परेशान करे, जैसे भाग जाना या ख़तरा न भाँपना, उसे जोड़ें।',
    sources: [{ label: 'टेली-मानस (भारत सरकार)', href: 'https://telemanas.mohfw.gov.in/' }],
  },
};
